import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useWorkSpacesStore = defineStore(
    'workSpacesStore',
    () => {
        const UserWorkSpace = ref({});

        // Get UserWorkSpace
        const getUserWorkSpace = computed(() => UserWorkSpace.value);

        // Set logged in state       
        const setUserWorkSpace = (value) => {
          UserWorkSpace.value = value;
        };

        return {
          UserWorkSpace,
          setUserWorkSpace,
          getUserWorkSpace,
        };
    },
    {
        persist: true,
    }
);
